import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { AdminNavigationComponent } from './navigation.component';

@Component({
  selector: 'squadbox-admin',
  imports: [RouterOutlet, AdminNavigationComponent],
  template: `
    <div class="flex h-screen bg-gradient-e-vertical overflow-hidden">
      <squadbox-admin-navigation></squadbox-admin-navigation>
      <div class="flex-1 min-w-0 overflow-auto">
        <router-outlet></router-outlet>
      </div>
    </div>
  `,
})
export class AdminPage {}
